// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   Page sections
------------------------------------------------------------------- */

/* ---------- Hero ---------- */
.hero {
  position: relative;
  min-height: 100svh;
  display: flex;
  align-items: center;
  padding-block: calc(var(--nav-h) + 3rem) 3rem;
}
.hero__inner {
  width: 100%;
  max-width: var(--maxw);
  margin-inline: auto;
  padding-inline: var(--gutter);
  display: grid;
  gap: clamp(2.5rem, 1.5rem + 4vw, 4rem);
  align-items: center;
}
@media (min-width: 1000px) {
  .hero__inner { grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr); }
}
/* Below the split point it stacks under the calls to action rather than
   disappearing — it is the most interesting thing on the page. */
@media (max-width: 999px) {
  .hero { min-height: 0; padding-bottom: 4rem; }
  /* The hero no longer fills the viewport here, so the cue has nothing
     to point at. */
  .hero__scroll { display: none; }
}

.hero__status {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  font-family: var(--font-mono);
  font-size: var(--step--1);
  color: var(--text-dim);
  letter-spacing: 0.02em;
}
.hero__status i {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: var(--ok);
  animation: ping 2.6s var(--ease-in-out) infinite;
}
@keyframes ping {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}

.hero__name {
  font-size: var(--step-5);
  line-height: 0.92;
  margin-block: 1.4rem 0.4rem;
  letter-spacing: -0.045em;
}
.hero__name span { display: block; }
/* The surname carries the accent; the rest stays ink. */
.hero__name span:last-child { color: var(--accent); }

.hero__roles {
  font-family: var(--font-mono);
  font-size: clamp(1rem, 0.86rem + 0.7vw, 1.5rem);
  color: var(--text-soft);
  min-height: 1.7em;
  display: flex;
  align-items: center;
  gap: 0.1rem;
}
.hero__roles b { color: var(--accent); font-weight: 500; }
.caret {
  display: inline-block;
  width: 0.6ch;
  height: 1.05em;
  margin-left: 0.15em;
  translate: 0 0.14em;
  background: var(--accent);
  animation: blink 1.05s steps(1) infinite;
}
@keyframes blink { 50% { opacity: 0; } }

.hero__lede {
  margin-top: 1.4rem;
  max-width: 56ch;
  font-size: var(--step-1);
  color: var(--text-soft);
}

.hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-top: 2.2rem;
}

.socials {
  display: flex;
  gap: 0.55rem;
  margin-top: 2rem;
}

.hero__scroll {
  position: absolute;
  left: 50%;
  bottom: 1.6rem;
  transform: translateX(-50%);
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-mono);
  font-size: 0.66rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--text-dim);
}
.hero__scroll i {
  width: 1px;
  height: 42px;
  background: linear-gradient(to bottom, var(--accent), transparent);
  animation: trickle 2.2s var(--ease-in-out) infinite;
  transform-origin: top;
}
@keyframes trickle {
  0% { transform: scaleY(0); opacity: 0; }
  40% { transform: scaleY(1); opacity: 1; }
  100% { transform: scaleY(1) translateY(42px); opacity: 0; }
}
@media (max-height: 700px) { .hero__scroll { display: none; } }

/* ---------- Stat counters ---------- */
.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 190px), 1fr));
  gap: 1px;
  background: var(--line);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  overflow: hidden;
}
.stat {
  background: color-mix(in srgb, var(--bg) 82%, transparent);
  padding: clamp(1.2rem, 1rem + 1vw, 1.9rem);
  transition: background-color 0.3s var(--ease);
}
.stat:hover { background: var(--surface-strong); }
.stat__value {
  font-size: var(--step-3);
  font-weight: 700;
  letter-spacing: -0.04em;
  font-variant-numeric: tabular-nums;
  color: var(--accent);
}
.stat__label {
  margin-top: 0.35rem;
  font-size: var(--step--1);
  color: var(--text-dim);
  font-family: var(--font-mono);
  line-height: 1.5;
}

/* ---------- Marquee ---------- */
.marquee {
  position: relative;
  overflow: hidden;
  border-block: 1px solid var(--line);
  padding-block: 0.9rem;
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
}
.marquee__track {
  display: flex;
  width: max-content;
  animation: slide 38s linear infinite;
}
.marquee:hover .marquee__track { animation-play-state: paused; }
.marquee__item {
  display: inline-flex;
  align-items: center;
  gap: 1.6rem;
  padding-inline-end: 1.6rem;
  font-family: var(--font-mono);
  font-size: var(--step--1);
  letter-spacing: 0.05em;
  color: var(--text-dim);
  white-space: nowrap;
}
.marquee__item::after {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--accent);
  opacity: 0.55;
  flex: none;
}
/* Two identical halves, translated exactly -50% — no seam. */
@keyframes slide {
  from { transform: translate3d(0, 0, 0); }
  to { transform: translate3d(-50%, 0, 0); }
}

/* No float animation here: the panel holds a live text input, and a moving
   click target is worse than a still one. */
.hero__panel { position: relative; }
.hero__panel .terminal { box-shadow: var(--shadow-lg); }

/* ---------- About / terminal ---------- */
.about {
  display: grid;
  gap: clamp(1.6rem, 1rem + 2.5vw, 3rem);
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
}
@media (min-width: 940px) {
  .about { grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.85fr); }
}

.about__copy p + p { margin-top: 1.1rem; }
.about__copy p { color: var(--text-soft); }

.portrait {
  position: relative;
  border-radius: var(--r-xl);
  overflow: hidden;
  border: 1px solid var(--line);
  aspect-ratio: 4 / 5;
  background: var(--surface);
}
.portrait img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(0.35) contrast(1.05);
  transition: filter 0.6s var(--ease), transform 0.9s var(--ease);
}
.portrait:hover img { filter: none; transform: scale(1.04); }
.portrait::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(180deg, transparent 45%, color-mix(in srgb, var(--bg) 88%, transparent));
}
.portrait__tag {
  position: absolute;
  left: 1rem;
  bottom: 1rem;
  z-index: 2;
  font-family: var(--font-mono);
  font-size: var(--step--1);
  color: var(--text-soft);
}
.portrait__tag b { display: block; color: var(--text); font-size: var(--step-0); }

.terminal {
  border-radius: var(--r-lg);
  border: 1px solid var(--line);
  background: var(--bg-elev);
  overflow: hidden;
  font-family: var(--font-mono);
  font-size: var(--step--1);
  box-shadow: var(--shadow-md);
}
[data-theme="light"] .terminal { background: #17150f; }
.terminal__bar {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.65rem 0.9rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}
.terminal__bar i {
  width: 11px; height: 11px;
  border-radius: 50%;
  background: #ff5f57;
}
.terminal__bar i:nth-child(2) { background: #febc2e; }
.terminal__bar i:nth-child(3) { background: #28c840; }
.terminal__bar span {
  margin-left: auto;
  color: #8791aa;
  font-size: 0.68rem;
  letter-spacing: 0.08em;
}
.terminal__body {
  padding: 1rem 1.1rem 1.3rem;
  display: grid;
  gap: 0.42rem;
  color: #b6bed2;
  height: 340px;
  max-height: 52vh;
  overflow-y: auto;
  align-content: start;
  cursor: text;
  scrollbar-width: thin;
}
@media (max-width: 999px) { .terminal__body { height: 300px; } }

.terminal__body::-webkit-scrollbar { width: 8px; }
.terminal__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.14);
  border-radius: 99px;
}

.terminal__line--err { color: var(--bad); }

/* Live prompt */
.terminal__prompt {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  cursor: text;
}
.terminal__prompt b { color: var(--accent); font-weight: 500; flex: none; }
.terminal__input {
  flex: none;
  min-width: 0;
  max-width: calc(100% - 2.5rem);
  border: 0;
  outline: none;
  background: none;
  color: #eef2ff;
  font: inherit;
  padding: 0;
  caret-color: transparent;
}
/* The blinking block sits after the text, so hide the native caret. */
.terminal__prompt .caret { margin-left: -0.4rem; flex: none; }

.terminal__hint {
  display: flex;
  flex-wrap: wrap;
  gap: 0.9rem;
  padding: 0.6rem 1.1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
  font-size: 0.66rem;
  color: #8791aa;
}
.terminal__hint kbd {
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.07);
  color: #b6bed2;
  font-size: 0.64rem;
}

/* Command output tables */
.term__grid { display: grid; gap: 0.3rem; }
.term__row {
  display: grid;
  grid-template-columns: minmax(0, 8.5rem) minmax(0, 1fr);
  gap: 0.8rem;
  align-items: baseline;
}
.term__row b { color: var(--accent); font-weight: 500; }
.term__row em { font-style: normal; color: #b6bed2; }
.term__note { color: #8791aa; margin-top: 0.35rem; display: block; }
@media (max-width: 560px) {
  .term__row { grid-template-columns: minmax(0, 1fr); gap: 0; }
  .term__row b { color: var(--accent); }
}
.terminal__line { display: flex; gap: 0.55rem; }
.terminal__line b { color: var(--accent); font-weight: 500; flex: none; }
.terminal__line--out { padding-left: 1.35rem; color: #9aa4bb; }
.terminal__line em { font-style: normal; color: #eef2ff; }
.terminal__line u { text-decoration: none; color: var(--accent-quiet); }

/* ---------- Timeline ---------- */
.timeline {
  position: relative;
  display: grid;
  gap: 1rem;
}
.timeline::before {
  content: "";
  position: absolute;
  left: 27px;
  top: 12px;
  bottom: 12px;
  width: 1px;
  background: linear-gradient(to bottom, transparent, var(--line-strong) 12%, var(--line-strong) 88%, transparent);
}
@media (max-width: 700px) { .timeline::before { left: 19px; } }

.tl-item {
  position: relative;
  padding-left: 66px;
}
@media (max-width: 700px) { .tl-item { padding-left: 48px; } }

.tl-item__node {
  position: absolute;
  left: 8px;
  top: 20px;
  width: 38px; height: 38px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--line-strong);
  background: var(--bg-elev);
  display: grid;
  place-items: center;
  z-index: 1;
  transition: border-color 0.3s var(--ease), box-shadow 0.3s var(--ease);
}
@media (max-width: 700px) {
  .tl-item__node { left: 0; width: 38px; }
}
.tl-item__node img { width: 100%; height: 100%; object-fit: cover; }
.tl-item:hover .tl-item__node {
  border-color: var(--accent);
  box-shadow: 0 0 0 4px color-mix(in srgb, var(--accent) 14%, transparent);
}

/* On a phone the rail eats a sixth of the screen. Drop it and let the logo
   sit above the card at full width instead. */
@media (max-width: 620px) {
  .timeline::before { display: none; }
  .tl-item { padding-left: 0; }
  .tl-item__node {
    position: static;
    margin-bottom: 0.7rem;
  }
}

.tl-card { width: 100%; }
.tl-card__head {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem);
  text-align: left;
}
.tl-card__meta { flex: 1 1; min-width: 0; }
.tl-card__period,
.tl-card__role,
.tl-card__company,
.tl-card__summary { display: block; }

.tl-card__period {
  font-family: var(--font-mono);
  font-weight: 500;
  font-size: var(--step--1);
  color: var(--accent);
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.tl-card__period small {
  display: inline-block;
  font-size: 0.6rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  padding: 0.14rem 0.42rem;
  border-radius: var(--r-sm);
  background: transparent;
  color: var(--ok);
  border: 1px solid var(--ok);
}
.tl-card__role {
  font-size: var(--step-2);
  font-weight: 700;
  letter-spacing: -0.028em;
  line-height: 1.15;
  margin-top: 0.3rem;
}
.tl-card__company { color: var(--text-soft); font-size: var(--step-0); }
.tl-card__summary { color: var(--text-dim); margin-top: 0.5rem; font-size: var(--step-0); }
.tl-card__toggle {
  flex: none;
  width: 34px; height: 34px;
  border-radius: 50%;
  border: 1px solid var(--line);
  display: grid;
  place-items: center;
  color: var(--text-soft);
  transition: transform 0.35s var(--ease), color 0.25s var(--ease), border-color 0.25s var(--ease);
}
.tl-card__head[aria-expanded="true"] .tl-card__toggle {
  transform: rotate(180deg);
  color: var(--accent);
  border-color: var(--accent);
}

/* Grid-rows trick: animatable height with no JS measuring. */
.tl-card__panel {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.42s var(--ease);
}
.tl-card__panel[data-open="true"] { grid-template-rows: 1fr; }
.tl-card__panel > div { overflow: hidden; }
.tl-card__panel-inner {
  padding: 0 clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem) clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem);
}
.tl-card__list { display: grid; gap: 0.6rem; margin-bottom: 1.1rem; }
.tl-card__list li {
  position: relative;
  padding-left: 1.4rem;
  color: var(--text-soft);
  font-size: var(--step-0);
}
.tl-card__list li::before {
  content: "▸";
  position: absolute;
  left: 0;
  color: var(--accent);
  font-size: 0.8em;
  top: 0.28em;
}

/* ---------- Skills ---------- */
.skill-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.8rem;
}
.skill-filter {
  padding: 0.45rem 0.95rem;
  border-radius: var(--r-sm);
  border: 1px solid var(--line);
  background: var(--surface);
  font-size: var(--step--1);
  font-family: var(--font-mono);
  color: var(--text-dim);
  transition: color 0.22s var(--ease), border-color 0.22s var(--ease),
    background-color 0.22s var(--ease), transform 0.22s var(--ease);
}
.skill-filter:hover { color: var(--text); transform: translateY(-2px); }
.skill-filter[aria-pressed="true"] {
  color: var(--accent-ink);
  background: var(--accent);
  border-color: var(--accent);
}

.skill-group { padding: clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem); }
.skill-group__title {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-family: var(--font-mono);
  font-size: var(--step--1);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--accent);
  margin-bottom: 0.95rem;
}
.skill-group__title span {
  flex: 1 1;
  height: 1px;
  background: var(--line);
}
.skill-group__count { color: var(--text-dim); letter-spacing: 0; }

/* ---------- Projects ---------- */
.pcard {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.pcard__media {
  position: relative;
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: var(--surface-strong);
}
.pcard__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.8s var(--ease), filter 0.5s var(--ease);
  filter: saturate(0.75) contrast(1.05);
}
.pcard:hover .pcard__media img { transform: scale(1.07); filter: saturate(1.05); }
.pcard__media::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 40%, color-mix(in srgb, var(--bg) 92%, transparent));
}
.pcard__year {
  position: absolute;
  top: 0.75rem; right: 0.75rem;
  z-index: 2;
  font-family: var(--font-mono);
  font-size: 0.68rem;
  padding: 0.22rem 0.55rem;
  border-radius: var(--r-sm);
  background: var(--bg);
  border: 1px solid var(--line);
  color: var(--text-soft);
}
/* A real credential, not a category label — so it carries the accent. */
.pcard__year[data-badge="true"] {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--accent-ink);
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.pcard__body {
  padding: clamp(1.05rem, 0.9rem + 0.5vw, 1.4rem);
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  flex: 1 1;
}
.pcard__title {
  font-size: var(--step-1);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.pcard__title svg {
  opacity: 0;
  transform: translate(-4px, 4px);
  transition: opacity 0.3s var(--ease), transform 0.3s var(--ease);
  color: var(--accent);
}
.pcard:hover .pcard__title svg { opacity: 1; transform: none; }
.pcard__blurb { color: var(--text-soft); font-size: var(--step-0); flex: 1 1; }

/* ---------- Repo cards (live GitHub) ---------- */
.repo {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 1.2rem;
  height: 100%;
}
.repo__name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-mono);
  font-size: var(--step-0);
  font-weight: 500;
  color: var(--text);
  word-break: break-word;
}
.repo__name svg { color: var(--accent); flex: none; }
.repo__desc { color: var(--text-soft); font-size: var(--step--1); flex: 1 1; }
.repo__foot {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-family: var(--font-mono);
  font-size: 0.7rem;
  color: var(--text-dim);
  flex-wrap: wrap;
}
.repo__foot span { display: inline-flex; align-items: center; gap: 0.35rem; }
.repo__dot {
  width: 9px; height: 9px;
  border-radius: 50%;
  background: var(--accent);
}
.skeleton {
  border-radius: var(--r-lg);
  border: 1px solid var(--line);
  background: linear-gradient(100deg, var(--surface) 30%, var(--surface-strong) 50%, var(--surface) 70%);
  background-size: 220% 100%;
  animation: sweep 1.4s linear infinite;
  min-height: 150px;
}
@keyframes sweep {
  from { background-position: 180% 0; }
  to { background-position: -80% 0; }
}

/* ---------- Education / awards ---------- */
.edu { padding: clamp(1.1rem, 0.9rem + 0.6vw, 1.6rem); }
.edu__head {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  margin-bottom: 0.9rem;
}
.edu__logo {
  width: 46px; height: 46px;
  border-radius: 12px;
  object-fit: cover;
  border: 1px solid var(--line);
  flex: none;
  background: var(--surface-strong);
}
.edu__degree { font-size: var(--step-1); }
.edu__school { color: var(--text-soft); font-size: var(--step--1); }
.edu__row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  font-family: var(--font-mono);
  font-size: var(--step--1);
  color: var(--text-dim);
  margin-bottom: 1rem;
}
.edu__row b { color: var(--accent); font-weight: 500; }
.edu__sub {
  font-family: var(--font-mono);
  font-size: 0.68rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-dim);
  margin-bottom: 0.55rem;
}
.edu__block + .edu__block { margin-top: 1.1rem; }

.award {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.2rem;
  border-bottom: 1px solid var(--line);
  transition: background-color 0.25s var(--ease), padding-left 0.25s var(--ease);
}
ul li:last-child > .award { border-bottom: 0; }
.award--link .award__icon { color: var(--accent); border-color: var(--accent); }
.award--link:hover .award__title { color: var(--accent); }
.award:hover { background: var(--surface); padding-left: 1.6rem; }
.award__icon {
  width: 34px; height: 34px;
  flex: none;
  display: grid;
  place-items: center;
  border-radius: 10px;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--accent);
}
.award__title { font-weight: 600; }
.award__org { color: var(--text-dim); font-size: var(--step--1); }
.award__year {
  margin-left: auto;
  font-family: var(--font-mono);
  font-size: var(--step--1);
  color: var(--text-dim);
  white-space: nowrap;
}

/* ---------- Contact ---------- */
.contact-grid {
  display: grid;
  gap: clamp(1.4rem, 1rem + 2vw, 2.6rem);
  grid-template-columns: minmax(0, 1fr);
}
@media (min-width: 900px) {
  .contact-grid { grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr); }
}
.contact-grid > .reveal { display: grid; }

.field { display: grid; gap: 0.4rem; }
.field label {
  font-family: var(--font-mono);
  font-size: 0.68rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-dim);
}
.field input,
.field textarea {
  width: 100%;
  padding: 0.8rem 0.95rem;
  border-radius: var(--r-md);
  border: 1px solid var(--line);
  background: var(--surface);
  outline: none;
  transition: border-color 0.22s var(--ease), background-color 0.22s var(--ease), box-shadow 0.22s var(--ease);
}
.field input:focus,
.field textarea:focus {
  border-color: var(--accent);
  background: var(--surface-strong);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 16%, transparent);
}
.field textarea { resize: vertical; min-height: 130px; }
.field__error { color: var(--bad); font-size: var(--step--1); font-family: var(--font-mono); }

.form { display: grid; gap: 1rem; }
.form__row {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 200px), 1fr));
}
.form__note {
  font-family: var(--font-mono);
  font-size: var(--step--1);
  color: var(--text-dim);
}
.form__status {
  padding: 0.8rem 1rem;
  border-radius: var(--r-md);
  border: 1px solid var(--ok);
  background: transparent;
  color: var(--ok);
  font-family: var(--font-mono);
  font-size: var(--step--1);
}
.form__status[data-kind="error"] {
  border-color: var(--bad);
  background: transparent;
  color: var(--bad);
}

.contact-card {
  padding: clamp(1.2rem, 1rem + 0.8vw, 1.9rem);
  display: flex;
  flex-direction: column;
}
.contact-card__foot {
  margin-top: auto;
  padding-top: 1.4rem;
}
.contact-card__now {
  color: var(--text-soft);
  font-size: var(--step-0);
  margin-top: 0.3rem;
}
.contact-line {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding-block: 0.85rem;
  border-bottom: 1px solid var(--line);
}
.contact-line:last-of-type { border-bottom: 0; }
.contact-line__icon {
  width: 36px; height: 36px;
  flex: none;
  display: grid;
  place-items: center;
  border-radius: 11px;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--accent);
}
.contact-line__label {
  font-family: var(--font-mono);
  font-size: 0.64rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--text-dim);
}
.contact-line__value { font-weight: 500; word-break: break-word; }

/* ---------- CTA band ---------- */
.cta {
  position: relative;
  border-block: 1px solid var(--line);
  padding: clamp(2.4rem, 1.8rem + 3vw, 4rem) 0;
  text-align: center;
}
@keyframes spin { to { transform: rotate(1turn); } }
.cta__title { font-size: var(--step-3); }
.cta__lede { color: var(--text-soft); max-width: 52ch; margin: 0.8rem auto 1.8rem; }
.cta__actions { display: flex; flex-wrap: wrap; gap: 0.8rem; justify-content: center; }

/* ---------- Footer ---------- */
.footer {
  border-top: 1px solid var(--line);
  padding-block: 2.4rem 2rem;
  margin-top: auto;
}
.footer__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.2rem;
}
.footer__brand { margin-right: auto; }
.footer__copy { color: var(--text-dim); font-size: var(--step--1); font-family: var(--font-mono); }
.footer__links { display: flex; gap: 0.5rem; flex-wrap: wrap; }
.footer__meta {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1.6rem;
  padding-top: 1.4rem;
  border-top: 1px solid var(--line);
  font-family: var(--font-mono);
  font-size: 0.68rem;
  color: var(--text-dim);
}
.footer__meta b { color: var(--ok); font-weight: 500; }

/* ---------- 404 ---------- */
.notfound {
  min-height: 100svh;
  display: grid;
  place-items: center;
  text-align: center;
  padding: calc(var(--nav-h) + 2rem) var(--gutter) 4rem;
}
.glitch {
  position: relative;
  font-size: var(--step-5);
  font-family: var(--font-mono);
  font-weight: 700;
  letter-spacing: -0.05em;
  line-height: 1;
  color: var(--text);
}
.glitch::before,
.glitch::after {
  content: attr(data-text);
  position: absolute;
  inset: 0;
  background: var(--bg);
  clip-path: inset(0 0 60% 0);
}
.glitch::before {
  color: var(--accent);
  animation: glitchA 3.2s steps(2, end) infinite;
}
.glitch::after {
  color: var(--text-dim);
  clip-path: inset(60% 0 0 0);
  animation: glitchB 2.7s steps(2, end) infinite;
}
@keyframes glitchA {
  0%, 88%, 100% { transform: none; opacity: 0; }
  90% { transform: translate(-4px, 2px); opacity: 1; }
  94% { transform: translate(3px, -2px); opacity: 1; }
}
@keyframes glitchB {
  0%, 85%, 100% { transform: none; opacity: 0; }
  88% { transform: translate(4px, -2px); opacity: 1; }
  92% { transform: translate(-3px, 2px); opacity: 1; }
}

/* ---------- Route loader ---------- */
.route-loader {
  min-height: 70svh;
  display: grid;
  place-items: center;
  gap: 1rem;
}
.spinner {
  width: 34px; height: 34px;
  border-radius: 50%;
  border: 2px solid var(--line-strong);
  border-top-color: var(--accent);
  animation: spin 0.8s linear infinite;
}

/* ---------- Case study ---------- */
.prose { max-width: 72ch; }
.prose h2 { font-size: var(--step-2); margin-top: 2.4rem; margin-bottom: 0.8rem; }
.prose p { color: var(--text-soft); }
.prose p + p { margin-top: 1rem; }
.prose ul { display: grid; gap: 0.55rem; margin-top: 1rem; }
.prose li {
  position: relative;
  padding-left: 1.4rem;
  color: var(--text-soft);
}
.prose li::before {
  content: "▸";
  position: absolute;
  left: 0;
  top: 0.1em;
  color: var(--accent);
  font-size: 0.85em;
}

.shot {
  border-radius: var(--r-lg);
  overflow: hidden;
  border: 1px solid var(--line);
  margin-block: 2rem;
  background: var(--surface);
}

/* ---------- Architecture diagram ---------- */
.arch {
  display: grid;
  gap: clamp(1.2rem, 0.8rem + 1.6vw, 2rem);
  align-items: start;
}
@media (min-width: 1040px) {
  .arch { grid-template-columns: minmax(0, 1fr) minmax(0, 300px); }
}

.arch__canvas {
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  background: var(--surface);
  padding: clamp(0.6rem, 0.4rem + 0.8vw, 1.1rem);
  overflow-x: auto;
}
.arch__svg {
  width: 100%;
  min-width: 620px;
  height: auto;
  display: block;
}

.arch__edge {
  fill: none;
  stroke: var(--line-strong);
  stroke-width: 1.5;
  color: var(--line-strong);
  transition: stroke 0.3s var(--ease), color 0.3s var(--ease), stroke-width 0.3s var(--ease);
}
[data-lit="true"] .arch__edge {
  stroke: var(--accent);
  color: var(--accent);
  stroke-width: 2;
}
.arch__packet { fill: var(--accent); }

.arch__node { cursor: pointer; outline: none; }
.arch__node rect {
  fill: var(--bg-elev);
  stroke: var(--line-strong);
  stroke-width: 1.5;
  transition: stroke 0.28s var(--ease), fill 0.28s var(--ease), filter 0.28s var(--ease);
}
.arch__node[data-near="true"] rect { stroke: color-mix(in srgb, var(--node-color) 55%, transparent); }
.arch__node[data-active="true"] rect {
  stroke: var(--node-color);
  stroke-width: 2;
  fill: var(--surface-strong);
}
.arch__node:hover rect { stroke: var(--node-color); }
.arch__node:focus-visible rect { stroke: var(--node-color); stroke-width: 2.5; }

.arch__label {
  fill: var(--text);
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 600;
  text-anchor: middle;
  pointer-events: none;
}
.arch__sub {
  fill: var(--text-dim);
  font-family: var(--font-mono);
  font-size: 11px;
  text-anchor: middle;
  pointer-events: none;
}

.arch__panel {
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  background: var(--surface);
  padding: clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem);
  position: sticky;
  top: calc(var(--nav-h) + 1.2rem);
}
.arch__panel-eyebrow {
  font-family: var(--font-mono);
  font-size: 0.64rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}
.arch__panel-title { font-size: var(--step-2); margin: 0.3rem 0 0.7rem; }
.arch__panel-body { color: var(--text-soft); font-size: var(--step-0); margin-bottom: 1rem; }
.arch__panel-foot {
  margin-top: 1.2rem;
  padding-top: 0.9rem;
  border-top: 1px solid var(--line);
  font-family: var(--font-mono);
  font-size: 0.68rem;
  color: var(--text-dim);
}

/* A moving dot is exactly what "reduce motion" is asking us not to do. */
@media (prefers-reduced-motion: reduce) {
  .arch__packet { display: none; }
}

/* ---------- Live GitHub activity ---------- */
.activity { padding: clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem); }
.activity__head {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding-bottom: 0.9rem;
  border-bottom: 1px solid var(--line);
  flex-wrap: wrap;
}
.activity__head h3 {
  font-size: var(--step-0);
  font-weight: 600;
  letter-spacing: 0;
}
.activity__head svg { color: var(--text-soft); }
.activity__pulse {
  width: 8px; height: 8px;
  border-radius: 50%;
  background: var(--ok);
  animation: ping 2.2s var(--ease-in-out) infinite;
}
.activity__all {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-family: var(--font-mono);
  font-size: 0.7rem;
  color: var(--text-dim);
}
.activity__all:hover { color: var(--accent); }

.activity__list { display: grid; }
.activity__row {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr) auto;
  align-items: baseline;
  gap: 0.6rem;
  padding: 0.62rem 0.2rem;
  border-bottom: 1px solid var(--line);
  font-family: var(--font-mono);
  font-size: var(--step--1);
  transition: padding-left 0.22s var(--ease), background-color 0.22s var(--ease);
}
.activity__list li:last-child .activity__row { border-bottom: 0; }
.activity__row:hover { background: var(--surface); padding-left: 0.7rem; }
.activity__verb { color: var(--accent); white-space: nowrap; }
.activity__repo { color: var(--text); white-space: nowrap; }
.activity__detail {
  color: var(--text-dim);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.activity__when { color: var(--text-dim); white-space: nowrap; }

.activity__row--skeleton { grid-template-columns: 1fr; }
.skeleton-bar {
  height: 12px;
  border-radius: 99px;
  background: linear-gradient(100deg, var(--surface) 30%, var(--surface-strong) 50%, var(--surface) 70%);
  background-size: 220% 100%;
  animation: sweep 1.4s linear infinite;
}

@media (max-width: 720px) {
  .activity__row { grid-template-columns: auto minmax(0, 1fr); row-gap: 0.15rem; }
  .activity__detail { grid-column: 1 / -1; }
  .activity__when { grid-column: 1 / -1; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/sections.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,eAAe,0DAA0D,EAAE;AAC7E;AACA;iEACiE;AACjE;EACE,QAAQ,aAAa,EAAE,oBAAoB,EAAE;EAC7C;mBACiB;EACjB,gBAAgB,aAAa,EAAE;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,gDAAgD;AAClD;AACA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA,mBAAmB,cAAc,EAAE;AACnC,wDAAwD;AACxD,8BAA8B,oBAAoB,EAAE;;AAEpD;EACE,6BAA6B;EAC7B,+CAA+C;EAC/C,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA,iBAAiB,oBAAoB,EAAE,gBAAgB,EAAE;AACzD;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;AACA,mBAAmB,MAAM,UAAU,EAAE,EAAE;;AAEvC;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kEAAkE;EAClE,mDAAmD;EACnD,qBAAqB;AACvB;AACA;EACE,KAAK,oBAAoB,EAAE,UAAU,EAAE;EACvC,MAAM,oBAAoB,EAAE,UAAU,EAAE;EACxC,OAAO,qCAAqC,EAAE,UAAU,EAAE;AAC5D;AACA,6BAA6B,gBAAgB,aAAa,EAAE,EAAE;;AAE9D,wCAAwC;AACxC;EACE,aAAa;EACb,sEAAsE;EACtE,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,0DAA0D;EAC1D,0CAA0C;EAC1C,6CAA6C;AAC/C;AACA,cAAc,iCAAiC,EAAE;AACjD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;EACrB,+EAA+E;EAC/E,uFAAuF;AACzF;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oCAAoC;AACtC;AACA,iCAAiC,4BAA4B,EAAE;AAC/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,UAAU;AACZ;AACA,6DAA6D;AAC7D;EACE,OAAO,+BAA+B,EAAE;EACxC,KAAK,kCAAkC,EAAE;AAC3C;;AAEA;4CAC4C;AAC5C,eAAe,kBAAkB,EAAE;AACnC,yBAAyB,4BAA4B,EAAE;;AAEvD,2CAA2C;AAC3C;EACE,aAAa;EACb,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,SAAS,0DAA0D,EAAE;AACvE;;AAEA,qBAAqB,kBAAkB,EAAE;AACzC,iBAAiB,uBAAuB,EAAE;;AAE1C;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,+DAA+D;AACjE;AACA,sBAAsB,YAAY,EAAE,sBAAsB,EAAE;AAC5D;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,oGAAoG;AACtG;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;AACzB;AACA,mBAAmB,cAAc,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;;AAEjF;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;AAC9B;AACA,iCAAiC,mBAAmB,EAAE;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kDAAkD;EAClD,qCAAqC;AACvC;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,gCAAgC,mBAAmB,EAAE;AACrD,gCAAgC,mBAAmB,EAAE;AACrD;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;AACvB;AACA,4BAA4B,kBAAkB,aAAa,EAAE,EAAE;;AAE/D,qCAAqC,UAAU,EAAE;AACjD;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,uBAAuB,iBAAiB,EAAE;;AAE1C,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;AACA,sBAAsB,oBAAoB,EAAE,gBAAgB,EAAE,UAAU,EAAE;AAC1E;EACE,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,UAAU;EACV,wBAAwB;AAC1B;AACA,sEAAsE;AACtE,2BAA2B,oBAAoB,EAAE,UAAU,EAAE;;AAE7D;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,+CAA+C;EAC/C,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,cAAc;EACd,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B,cAAc,aAAa,EAAE,WAAW,EAAE;AAC1C;EACE,aAAa;EACb,uDAAuD;EACvD,WAAW;EACX,qBAAqB;AACvB;AACA,eAAe,oBAAoB,EAAE,gBAAgB,EAAE;AACvD,gBAAgB,kBAAkB,EAAE,cAAc,EAAE;AACpD,cAAc,cAAc,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACnE;EACE,aAAa,qCAAqC,EAAE,MAAM,EAAE;EAC5D,eAAe,oBAAoB,EAAE;AACvC;AACA,kBAAkB,aAAa,EAAE,YAAY,EAAE;AAC/C,oBAAoB,oBAAoB,EAAE,gBAAgB,EAAE,UAAU,EAAE;AACxE,uBAAuB,qBAAqB,EAAE,cAAc,EAAE;AAC9D,qBAAqB,kBAAkB,EAAE,cAAc,EAAE;AACzD,oBAAoB,qBAAqB,EAAE,0BAA0B,EAAE;;AAEvE,mCAAmC;AACnC;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,gHAAgH;AAClH;AACA,4BAA4B,oBAAoB,UAAU,EAAE,EAAE;;AAE9D;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA,4BAA4B,WAAW,kBAAkB,EAAE,EAAE;;AAE7D;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,sEAAsE;AACxE;AACA;EACE,iBAAiB,OAAO,EAAE,WAAW,EAAE;AACzC;AACA,qBAAqB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AACnE;EACE,2BAA2B;EAC3B,wEAAwE;AAC1E;;AAEA;8CAC8C;AAC9C;EACE,oBAAoB,aAAa,EAAE;EACnC,WAAW,eAAe,EAAE;EAC5B;IACE,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA,WAAW,WAAW,EAAE;AACxB;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,8CAA8C;EAC9C,gBAAgB;AAClB;AACA,iBAAiB,SAAO,EAAE,YAAY,EAAE;AACxC;;;oBAGoB,cAAc,EAAE;;AAEpC;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,oBAAoB,uBAAuB,EAAE,wBAAwB,EAAE;AACvE,oBAAoB,sBAAsB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AAC1F;EACE,UAAU;EACV,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gGAAgG;AAClG;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,uBAAuB;EACvB,gDAAgD;AAClD;AACA,oCAAoC,uBAAuB,EAAE;AAC7D,wBAAwB,gBAAgB,EAAE;AAC1C;EACE,sFAAsF;AACxF;AACA,iBAAiB,aAAa,EAAE,WAAW,EAAE,qBAAqB,EAAE;AACpE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;EACtB;mEACiE;AACnE;AACA,sBAAsB,kBAAkB,EAAE,2BAA2B,EAAE;AACvE;EACE,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,eAAe,8CAA8C,EAAE;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,WAAW;EACX,uBAAuB;AACzB;AACA,sBAAsB,sBAAsB,EAAE,iBAAiB,EAAE;;AAEjE,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+DAA+D;EAC/D,qCAAqC;AACvC;AACA,iCAAiC,sBAAsB,EAAE,sBAAsB,EAAE;AACjF;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oGAAoG;AACtG;AACA;EACE,kBAAkB;EAClB,YAAY,EAAE,cAAc;EAC5B,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B;EAC7B,uBAAuB;AACzB;AACA,wEAAwE;AACxE;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAO;AACT;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,UAAU;EACV,+BAA+B;EAC/B,gEAAgE;EAChE,oBAAoB;AACtB;AACA,iCAAiC,UAAU,EAAE,eAAe,EAAE;AAC9D,gBAAgB,uBAAuB,EAAE,wBAAwB,EAAE,SAAO,EAAE;;AAE5E,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA,kBAAkB,oBAAoB,EAAE,UAAU,EAAE;AACpD,cAAc,uBAAuB,EAAE,yBAAyB,EAAE,SAAO,EAAE;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;AACA,mBAAmB,oBAAoB,EAAE,mBAAmB,EAAE,YAAY,EAAE;AAC5E;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,sGAAsG;EACtG,0BAA0B;EAC1B,qCAAqC;EACrC,iBAAiB;AACnB;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,2BAA2B,EAAE;AACpC;;AAEA,6CAA6C;AAC7C,OAAO,8CAA8C,EAAE;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,UAAU;EACV,iCAAiC;AACnC;AACA,eAAe,wBAAwB,EAAE;AACzC,eAAe,uBAAuB,EAAE,yBAAyB,EAAE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA,cAAc,oBAAoB,EAAE,gBAAgB,EAAE;AACtD;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;AACA,4BAA4B,kBAAkB,EAAE;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,oCAAoC;EACpC,8EAA8E;AAChF;AACA,4BAA4B,gBAAgB,EAAE;AAC9C,4BAA4B,oBAAoB,EAAE,2BAA2B,EAAE;AAC/E,mCAAmC,oBAAoB,EAAE;AACzD,eAAe,0BAA0B,EAAE,oBAAoB,EAAE;AACjE;EACE,WAAW,EAAE,YAAY;EACzB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;AACtB;AACA,gBAAgB,gBAAgB,EAAE;AAClC,cAAc,sBAAsB,EAAE,yBAAyB,EAAE;AACjE;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sCAAsC;EACtC,qCAAqC;AACvC;AACA;EACE,gBAAgB,0DAA0D,EAAE;AAC9E;AACA,0BAA0B,aAAa,EAAE;;AAEzC,SAAS,aAAa,EAAE,WAAW,EAAE;AACrC;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,4GAA4G;AAC9G;AACA;;EAEE,2BAA2B;EAC3B,iCAAiC;EACjC,wEAAwE;AAC1E;AACA,kBAAkB,gBAAgB,EAAE,iBAAiB,EAAE;AACvD,gBAAgB,iBAAiB,EAAE,yBAAyB,EAAE,6BAA6B,EAAE;;AAE7F,QAAQ,aAAa,EAAE,SAAS,EAAE;AAClC;EACE,aAAa;EACb,SAAS;EACT,sEAAsE;AACxE;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,oCAAoC;AACtC;AACA,6BAA6B,gBAAgB,EAAE;AAC/C;EACE,WAAW,EAAE,YAAY;EACzB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,uBAAuB,gBAAgB,EAAE,sBAAsB,EAAE;;AAEjE,mCAAmC;AACnC;EACE,kBAAkB;EAClB,mCAAmC;EACnC,4CAA4C;EAC5C,kBAAkB;AACpB;AACA,kBAAkB,KAAK,wBAAwB,EAAE,EAAE;AACnD,cAAc,wBAAwB,EAAE;AACxC,aAAa,uBAAuB,EAAE,eAAe,EAAE,0BAA0B,EAAE;AACnF,gBAAgB,aAAa,EAAE,eAAe,EAAE,WAAW,EAAE,uBAAuB,EAAE;;AAEtF,iCAAiC;AACjC;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;AACA,iBAAiB,kBAAkB,EAAE;AACrC,gBAAgB,sBAAsB,EAAE,yBAAyB,EAAE,6BAA6B,EAAE;AAClG,iBAAiB,aAAa,EAAE,WAAW,EAAE,eAAe,EAAE;AAC9D;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;AACxB;AACA,kBAAkB,gBAAgB,EAAE,gBAAgB,EAAE;;AAEtD,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;EACE,gBAAgB,eAAe,EAAE,UAAU,EAAE;EAC7C,MAAM,+BAA+B,EAAE,UAAU,EAAE;EACnD,MAAM,+BAA+B,EAAE,UAAU,EAAE;AACrD;AACA;EACE,gBAAgB,eAAe,EAAE,UAAU,EAAE;EAC7C,MAAM,+BAA+B,EAAE,UAAU,EAAE;EACnD,MAAM,+BAA+B,EAAE,UAAU,EAAE;AACrD;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC,SAAS,eAAe,EAAE;AAC1B,YAAY,wBAAwB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE;AACjF,WAAW,uBAAuB,EAAE;AACpC,eAAe,gBAAgB,EAAE;AACjC,YAAY,aAAa,EAAE,YAAY,EAAE,gBAAgB,EAAE;AAC3D;EACE,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,QAAQ,sDAAsD,EAAE;AAClE;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,8CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,0FAA0F;AAC5F;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;AACjB;AACA,gBAAgB,mBAAmB,EAAE;;AAErC,cAAc,eAAe,EAAE,aAAa,EAAE;AAC9C;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,iBAAiB;EACjB,sFAAsF;AACxF;AACA,qCAAqC,8DAA8D,EAAE;AACrG;EACE,yBAAyB;EACzB,eAAe;EACf,2BAA2B;AAC7B;AACA,yBAAyB,yBAAyB,EAAE;AACpD,iCAAiC,yBAAyB,EAAE,iBAAiB,EAAE;;AAE/E;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,8CAA8C;EAC9C,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA,qBAAqB,wBAAwB,EAAE,uBAAuB,EAAE;AACxE,oBAAoB,uBAAuB,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;AAC5F;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;EACE,gBAAgB,aAAa,EAAE;AACjC;;AAEA,+CAA+C;AAC/C,YAAY,8CAA8C,EAAE;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;AACA,sBAAsB,uBAAuB,EAAE;AAC/C;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;AACA,uBAAuB,oBAAoB,EAAE;;AAE7C,kBAAkB,aAAa,EAAE;AACjC;EACE,aAAa;EACb,oDAAoD;EACpD,qBAAqB;EACrB,WAAW;EACX,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,8EAA8E;AAChF;AACA,+CAA+C,gBAAgB,EAAE;AACjE,uBAAuB,0BAA0B,EAAE,oBAAoB,EAAE;AACzE,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE;AAC7D,kBAAkB,kBAAkB,EAAE,mBAAmB,EAAE;AAC3D;EACE,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,kBAAkB,sBAAsB,EAAE,mBAAmB,EAAE;;AAE/D,2BAA2B,0BAA0B,EAAE;AACvD;EACE,YAAY;EACZ,mBAAmB;EACnB,sGAAsG;EACtG,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB,0CAA0C,EAAE,gBAAgB,EAAE;EAC/E,oBAAoB,mBAAmB,EAAE;EACzC,kBAAkB,mBAAmB,EAAE;AACzC","sourcesContent":["/* ------------------------------------------------------------------\n   Page sections\n------------------------------------------------------------------- */\n\n/* ---------- Hero ---------- */\n.hero {\n  position: relative;\n  min-height: 100svh;\n  display: flex;\n  align-items: center;\n  padding-block: calc(var(--nav-h) + 3rem) 3rem;\n}\n.hero__inner {\n  width: 100%;\n  max-width: var(--maxw);\n  margin-inline: auto;\n  padding-inline: var(--gutter);\n  display: grid;\n  gap: clamp(2.5rem, 1.5rem + 4vw, 4rem);\n  align-items: center;\n}\n@media (min-width: 1000px) {\n  .hero__inner { grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr); }\n}\n/* Below the split point it stacks under the calls to action rather than\n   disappearing — it is the most interesting thing on the page. */\n@media (max-width: 999px) {\n  .hero { min-height: 0; padding-bottom: 4rem; }\n  /* The hero no longer fills the viewport here, so the cue has nothing\n     to point at. */\n  .hero__scroll { display: none; }\n}\n\n.hero__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n  color: var(--text-dim);\n  letter-spacing: 0.02em;\n}\n.hero__status i {\n  width: 7px; height: 7px;\n  border-radius: 50%;\n  background: var(--ok);\n  animation: ping 2.6s var(--ease-in-out) infinite;\n}\n@keyframes ping {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.35; }\n}\n\n.hero__name {\n  font-size: var(--step-5);\n  line-height: 0.92;\n  margin-block: 1.4rem 0.4rem;\n  letter-spacing: -0.045em;\n}\n.hero__name span { display: block; }\n/* The surname carries the accent; the rest stays ink. */\n.hero__name span:last-child { color: var(--accent); }\n\n.hero__roles {\n  font-family: var(--font-mono);\n  font-size: clamp(1rem, 0.86rem + 0.7vw, 1.5rem);\n  color: var(--text-soft);\n  min-height: 1.7em;\n  display: flex;\n  align-items: center;\n  gap: 0.1rem;\n}\n.hero__roles b { color: var(--accent); font-weight: 500; }\n.caret {\n  display: inline-block;\n  width: 0.6ch;\n  height: 1.05em;\n  margin-left: 0.15em;\n  translate: 0 0.14em;\n  background: var(--accent);\n  animation: blink 1.05s steps(1) infinite;\n}\n@keyframes blink { 50% { opacity: 0; } }\n\n.hero__lede {\n  margin-top: 1.4rem;\n  max-width: 56ch;\n  font-size: var(--step-1);\n  color: var(--text-soft);\n}\n\n.hero__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.8rem;\n  margin-top: 2.2rem;\n}\n\n.socials {\n  display: flex;\n  gap: 0.55rem;\n  margin-top: 2rem;\n}\n\n.hero__scroll {\n  position: absolute;\n  left: 50%;\n  bottom: 1.6rem;\n  transform: translateX(-50%);\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: var(--font-mono);\n  font-size: 0.66rem;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: var(--text-dim);\n}\n.hero__scroll i {\n  width: 1px;\n  height: 42px;\n  background: linear-gradient(to bottom, var(--accent), transparent);\n  animation: trickle 2.2s var(--ease-in-out) infinite;\n  transform-origin: top;\n}\n@keyframes trickle {\n  0% { transform: scaleY(0); opacity: 0; }\n  40% { transform: scaleY(1); opacity: 1; }\n  100% { transform: scaleY(1) translateY(42px); opacity: 0; }\n}\n@media (max-height: 700px) { .hero__scroll { display: none; } }\n\n/* ---------- Stat counters ---------- */\n.stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 190px), 1fr));\n  gap: 1px;\n  background: var(--line);\n  border: 1px solid var(--line);\n  border-radius: var(--r-lg);\n  overflow: hidden;\n}\n.stat {\n  background: color-mix(in srgb, var(--bg) 82%, transparent);\n  padding: clamp(1.2rem, 1rem + 1vw, 1.9rem);\n  transition: background-color 0.3s var(--ease);\n}\n.stat:hover { background: var(--surface-strong); }\n.stat__value {\n  font-size: var(--step-3);\n  font-weight: 700;\n  letter-spacing: -0.04em;\n  font-variant-numeric: tabular-nums;\n  color: var(--accent);\n}\n.stat__label {\n  margin-top: 0.35rem;\n  font-size: var(--step--1);\n  color: var(--text-dim);\n  font-family: var(--font-mono);\n  line-height: 1.5;\n}\n\n/* ---------- Marquee ---------- */\n.marquee {\n  position: relative;\n  overflow: hidden;\n  border-block: 1px solid var(--line);\n  padding-block: 0.9rem;\n  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);\n  -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);\n}\n.marquee__track {\n  display: flex;\n  width: max-content;\n  animation: slide 38s linear infinite;\n}\n.marquee:hover .marquee__track { animation-play-state: paused; }\n.marquee__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 1.6rem;\n  padding-inline-end: 1.6rem;\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n  letter-spacing: 0.05em;\n  color: var(--text-dim);\n  white-space: nowrap;\n}\n.marquee__item::after {\n  content: \"\";\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--accent);\n  opacity: 0.55;\n  flex: none;\n}\n/* Two identical halves, translated exactly -50% — no seam. */\n@keyframes slide {\n  from { transform: translate3d(0, 0, 0); }\n  to { transform: translate3d(-50%, 0, 0); }\n}\n\n/* No float animation here: the panel holds a live text input, and a moving\n   click target is worse than a still one. */\n.hero__panel { position: relative; }\n.hero__panel .terminal { box-shadow: var(--shadow-lg); }\n\n/* ---------- About / terminal ---------- */\n.about {\n  display: grid;\n  gap: clamp(1.6rem, 1rem + 2.5vw, 3rem);\n  grid-template-columns: minmax(0, 1fr);\n  align-items: start;\n}\n@media (min-width: 940px) {\n  .about { grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.85fr); }\n}\n\n.about__copy p + p { margin-top: 1.1rem; }\n.about__copy p { color: var(--text-soft); }\n\n.portrait {\n  position: relative;\n  border-radius: var(--r-xl);\n  overflow: hidden;\n  border: 1px solid var(--line);\n  aspect-ratio: 4 / 5;\n  background: var(--surface);\n}\n.portrait img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: grayscale(0.35) contrast(1.05);\n  transition: filter 0.6s var(--ease), transform 0.9s var(--ease);\n}\n.portrait:hover img { filter: none; transform: scale(1.04); }\n.portrait::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background: linear-gradient(180deg, transparent 45%, color-mix(in srgb, var(--bg) 88%, transparent));\n}\n.portrait__tag {\n  position: absolute;\n  left: 1rem;\n  bottom: 1rem;\n  z-index: 2;\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n  color: var(--text-soft);\n}\n.portrait__tag b { display: block; color: var(--text); font-size: var(--step-0); }\n\n.terminal {\n  border-radius: var(--r-lg);\n  border: 1px solid var(--line);\n  background: var(--bg-elev);\n  overflow: hidden;\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n  box-shadow: var(--shadow-md);\n}\n[data-theme=\"light\"] .terminal { background: #17150f; }\n.terminal__bar {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.65rem 0.9rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n}\n.terminal__bar i {\n  width: 11px; height: 11px;\n  border-radius: 50%;\n  background: #ff5f57;\n}\n.terminal__bar i:nth-child(2) { background: #febc2e; }\n.terminal__bar i:nth-child(3) { background: #28c840; }\n.terminal__bar span {\n  margin-left: auto;\n  color: #8791aa;\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n}\n.terminal__body {\n  padding: 1rem 1.1rem 1.3rem;\n  display: grid;\n  gap: 0.42rem;\n  color: #b6bed2;\n  height: 340px;\n  max-height: 52vh;\n  overflow-y: auto;\n  align-content: start;\n  cursor: text;\n  scrollbar-width: thin;\n}\n@media (max-width: 999px) { .terminal__body { height: 300px; } }\n\n.terminal__body::-webkit-scrollbar { width: 8px; }\n.terminal__body::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.14);\n  border-radius: 99px;\n}\n\n.terminal__line--err { color: var(--bad); }\n\n/* Live prompt */\n.terminal__prompt {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  cursor: text;\n}\n.terminal__prompt b { color: var(--accent); font-weight: 500; flex: none; }\n.terminal__input {\n  flex: none;\n  min-width: 0;\n  max-width: calc(100% - 2.5rem);\n  border: 0;\n  outline: none;\n  background: none;\n  color: #eef2ff;\n  font: inherit;\n  padding: 0;\n  caret-color: transparent;\n}\n/* The blinking block sits after the text, so hide the native caret. */\n.terminal__prompt .caret { margin-left: -0.4rem; flex: none; }\n\n.terminal__hint {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.9rem;\n  padding: 0.6rem 1.1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.02);\n  font-size: 0.66rem;\n  color: #8791aa;\n}\n.terminal__hint kbd {\n  border-color: rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.07);\n  color: #b6bed2;\n  font-size: 0.64rem;\n}\n\n/* Command output tables */\n.term__grid { display: grid; gap: 0.3rem; }\n.term__row {\n  display: grid;\n  grid-template-columns: minmax(0, 8.5rem) minmax(0, 1fr);\n  gap: 0.8rem;\n  align-items: baseline;\n}\n.term__row b { color: var(--accent); font-weight: 500; }\n.term__row em { font-style: normal; color: #b6bed2; }\n.term__note { color: #8791aa; margin-top: 0.35rem; display: block; }\n@media (max-width: 560px) {\n  .term__row { grid-template-columns: minmax(0, 1fr); gap: 0; }\n  .term__row b { color: var(--accent); }\n}\n.terminal__line { display: flex; gap: 0.55rem; }\n.terminal__line b { color: var(--accent); font-weight: 500; flex: none; }\n.terminal__line--out { padding-left: 1.35rem; color: #9aa4bb; }\n.terminal__line em { font-style: normal; color: #eef2ff; }\n.terminal__line u { text-decoration: none; color: var(--accent-quiet); }\n\n/* ---------- Timeline ---------- */\n.timeline {\n  position: relative;\n  display: grid;\n  gap: 1rem;\n}\n.timeline::before {\n  content: \"\";\n  position: absolute;\n  left: 27px;\n  top: 12px;\n  bottom: 12px;\n  width: 1px;\n  background: linear-gradient(to bottom, transparent, var(--line-strong) 12%, var(--line-strong) 88%, transparent);\n}\n@media (max-width: 700px) { .timeline::before { left: 19px; } }\n\n.tl-item {\n  position: relative;\n  padding-left: 66px;\n}\n@media (max-width: 700px) { .tl-item { padding-left: 48px; } }\n\n.tl-item__node {\n  position: absolute;\n  left: 8px;\n  top: 20px;\n  width: 38px; height: 38px;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid var(--line-strong);\n  background: var(--bg-elev);\n  display: grid;\n  place-items: center;\n  z-index: 1;\n  transition: border-color 0.3s var(--ease), box-shadow 0.3s var(--ease);\n}\n@media (max-width: 700px) {\n  .tl-item__node { left: 0; width: 38px; }\n}\n.tl-item__node img { width: 100%; height: 100%; object-fit: cover; }\n.tl-item:hover .tl-item__node {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 4px color-mix(in srgb, var(--accent) 14%, transparent);\n}\n\n/* On a phone the rail eats a sixth of the screen. Drop it and let the logo\n   sit above the card at full width instead. */\n@media (max-width: 620px) {\n  .timeline::before { display: none; }\n  .tl-item { padding-left: 0; }\n  .tl-item__node {\n    position: static;\n    margin-bottom: 0.7rem;\n  }\n}\n\n.tl-card { width: 100%; }\n.tl-card__head {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem);\n  text-align: left;\n}\n.tl-card__meta { flex: 1; min-width: 0; }\n.tl-card__period,\n.tl-card__role,\n.tl-card__company,\n.tl-card__summary { display: block; }\n\n.tl-card__period {\n  font-family: var(--font-mono);\n  font-weight: 500;\n  font-size: var(--step--1);\n  color: var(--accent);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.tl-card__period small {\n  display: inline-block;\n  font-size: 0.6rem;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  padding: 0.14rem 0.42rem;\n  border-radius: var(--r-sm);\n  background: transparent;\n  color: var(--ok);\n  border: 1px solid var(--ok);\n}\n.tl-card__role {\n  font-size: var(--step-2);\n  font-weight: 700;\n  letter-spacing: -0.028em;\n  line-height: 1.15;\n  margin-top: 0.3rem;\n}\n.tl-card__company { color: var(--text-soft); font-size: var(--step-0); }\n.tl-card__summary { color: var(--text-dim); margin-top: 0.5rem; font-size: var(--step-0); }\n.tl-card__toggle {\n  flex: none;\n  width: 34px; height: 34px;\n  border-radius: 50%;\n  border: 1px solid var(--line);\n  display: grid;\n  place-items: center;\n  color: var(--text-soft);\n  transition: transform 0.35s var(--ease), color 0.25s var(--ease), border-color 0.25s var(--ease);\n}\n.tl-card__head[aria-expanded=\"true\"] .tl-card__toggle {\n  transform: rotate(180deg);\n  color: var(--accent);\n  border-color: var(--accent);\n}\n\n/* Grid-rows trick: animatable height with no JS measuring. */\n.tl-card__panel {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.42s var(--ease);\n}\n.tl-card__panel[data-open=\"true\"] { grid-template-rows: 1fr; }\n.tl-card__panel > div { overflow: hidden; }\n.tl-card__panel-inner {\n  padding: 0 clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem) clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem);\n}\n.tl-card__list { display: grid; gap: 0.6rem; margin-bottom: 1.1rem; }\n.tl-card__list li {\n  position: relative;\n  padding-left: 1.4rem;\n  color: var(--text-soft);\n  font-size: var(--step-0);\n}\n.tl-card__list li::before {\n  content: \"▸\";\n  position: absolute;\n  left: 0;\n  color: var(--accent);\n  font-size: 0.8em;\n  top: 0.28em;\n}\n\n/* ---------- Skills ---------- */\n.skill-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1.8rem;\n}\n.skill-filter {\n  padding: 0.45rem 0.95rem;\n  border-radius: var(--r-sm);\n  border: 1px solid var(--line);\n  background: var(--surface);\n  font-size: var(--step--1);\n  font-family: var(--font-mono);\n  color: var(--text-dim);\n  transition: color 0.22s var(--ease), border-color 0.22s var(--ease),\n    background-color 0.22s var(--ease), transform 0.22s var(--ease);\n}\n.skill-filter:hover { color: var(--text); transform: translateY(-2px); }\n.skill-filter[aria-pressed=\"true\"] {\n  color: var(--accent-ink);\n  background: var(--accent);\n  border-color: var(--accent);\n}\n\n.skill-group { padding: clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem); }\n.skill-group__title {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--accent);\n  margin-bottom: 0.95rem;\n}\n.skill-group__title span {\n  flex: 1;\n  height: 1px;\n  background: var(--line);\n}\n.skill-group__count { color: var(--text-dim); letter-spacing: 0; }\n\n/* ---------- Projects ---------- */\n.pcard {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.pcard__media {\n  position: relative;\n  aspect-ratio: 16 / 10;\n  overflow: hidden;\n  background: var(--surface-strong);\n}\n.pcard__media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.8s var(--ease), filter 0.5s var(--ease);\n  filter: saturate(0.75) contrast(1.05);\n}\n.pcard:hover .pcard__media img { transform: scale(1.07); filter: saturate(1.05); }\n.pcard__media::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, transparent 40%, color-mix(in srgb, var(--bg) 92%, transparent));\n}\n.pcard__year {\n  position: absolute;\n  top: 0.75rem; right: 0.75rem;\n  z-index: 2;\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  padding: 0.22rem 0.55rem;\n  border-radius: var(--r-sm);\n  background: var(--bg);\n  border: 1px solid var(--line);\n  color: var(--text-soft);\n}\n/* A real credential, not a category label — so it carries the accent. */\n.pcard__year[data-badge=\"true\"] {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--accent-ink);\n  font-weight: 500;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.pcard__body {\n  padding: clamp(1.05rem, 0.9rem + 0.5vw, 1.4rem);\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  flex: 1;\n}\n.pcard__title {\n  font-size: var(--step-1);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.pcard__title svg {\n  opacity: 0;\n  transform: translate(-4px, 4px);\n  transition: opacity 0.3s var(--ease), transform 0.3s var(--ease);\n  color: var(--accent);\n}\n.pcard:hover .pcard__title svg { opacity: 1; transform: none; }\n.pcard__blurb { color: var(--text-soft); font-size: var(--step-0); flex: 1; }\n\n/* ---------- Repo cards (live GitHub) ---------- */\n.repo {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  padding: 1.2rem;\n  height: 100%;\n}\n.repo__name {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: var(--font-mono);\n  font-size: var(--step-0);\n  font-weight: 500;\n  color: var(--text);\n  word-break: break-word;\n}\n.repo__name svg { color: var(--accent); flex: none; }\n.repo__desc { color: var(--text-soft); font-size: var(--step--1); flex: 1; }\n.repo__foot {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  color: var(--text-dim);\n  flex-wrap: wrap;\n}\n.repo__foot span { display: inline-flex; align-items: center; gap: 0.35rem; }\n.repo__dot {\n  width: 9px; height: 9px;\n  border-radius: 50%;\n  background: var(--accent);\n}\n.skeleton {\n  border-radius: var(--r-lg);\n  border: 1px solid var(--line);\n  background: linear-gradient(100deg, var(--surface) 30%, var(--surface-strong) 50%, var(--surface) 70%);\n  background-size: 220% 100%;\n  animation: sweep 1.4s linear infinite;\n  min-height: 150px;\n}\n@keyframes sweep {\n  from { background-position: 180% 0; }\n  to { background-position: -80% 0; }\n}\n\n/* ---------- Education / awards ---------- */\n.edu { padding: clamp(1.1rem, 0.9rem + 0.6vw, 1.6rem); }\n.edu__head {\n  display: flex;\n  align-items: center;\n  gap: 0.9rem;\n  margin-bottom: 0.9rem;\n}\n.edu__logo {\n  width: 46px; height: 46px;\n  border-radius: 12px;\n  object-fit: cover;\n  border: 1px solid var(--line);\n  flex: none;\n  background: var(--surface-strong);\n}\n.edu__degree { font-size: var(--step-1); }\n.edu__school { color: var(--text-soft); font-size: var(--step--1); }\n.edu__row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n  color: var(--text-dim);\n  margin-bottom: 1rem;\n}\n.edu__row b { color: var(--accent); font-weight: 500; }\n.edu__sub {\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-dim);\n  margin-bottom: 0.55rem;\n}\n.edu__block + .edu__block { margin-top: 1.1rem; }\n\n.award {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.2rem;\n  border-bottom: 1px solid var(--line);\n  transition: background-color 0.25s var(--ease), padding-left 0.25s var(--ease);\n}\nul li:last-child > .award { border-bottom: 0; }\n.award--link .award__icon { color: var(--accent); border-color: var(--accent); }\n.award--link:hover .award__title { color: var(--accent); }\n.award:hover { background: var(--surface); padding-left: 1.6rem; }\n.award__icon {\n  width: 34px; height: 34px;\n  flex: none;\n  display: grid;\n  place-items: center;\n  border-radius: 10px;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  color: var(--accent);\n}\n.award__title { font-weight: 600; }\n.award__org { color: var(--text-dim); font-size: var(--step--1); }\n.award__year {\n  margin-left: auto;\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n  color: var(--text-dim);\n  white-space: nowrap;\n}\n\n/* ---------- Contact ---------- */\n.contact-grid {\n  display: grid;\n  gap: clamp(1.4rem, 1rem + 2vw, 2.6rem);\n  grid-template-columns: minmax(0, 1fr);\n}\n@media (min-width: 900px) {\n  .contact-grid { grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr); }\n}\n.contact-grid > .reveal { display: grid; }\n\n.field { display: grid; gap: 0.4rem; }\n.field label {\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-dim);\n}\n.field input,\n.field textarea {\n  width: 100%;\n  padding: 0.8rem 0.95rem;\n  border-radius: var(--r-md);\n  border: 1px solid var(--line);\n  background: var(--surface);\n  outline: none;\n  transition: border-color 0.22s var(--ease), background-color 0.22s var(--ease), box-shadow 0.22s var(--ease);\n}\n.field input:focus,\n.field textarea:focus {\n  border-color: var(--accent);\n  background: var(--surface-strong);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent) 16%, transparent);\n}\n.field textarea { resize: vertical; min-height: 130px; }\n.field__error { color: var(--bad); font-size: var(--step--1); font-family: var(--font-mono); }\n\n.form { display: grid; gap: 1rem; }\n.form__row {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 200px), 1fr));\n}\n.form__note {\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n  color: var(--text-dim);\n}\n.form__status {\n  padding: 0.8rem 1rem;\n  border-radius: var(--r-md);\n  border: 1px solid var(--ok);\n  background: transparent;\n  color: var(--ok);\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n}\n.form__status[data-kind=\"error\"] {\n  border-color: var(--bad);\n  background: transparent;\n  color: var(--bad);\n}\n\n.contact-card {\n  padding: clamp(1.2rem, 1rem + 0.8vw, 1.9rem);\n  display: flex;\n  flex-direction: column;\n}\n.contact-card__foot {\n  margin-top: auto;\n  padding-top: 1.4rem;\n}\n.contact-card__now {\n  color: var(--text-soft);\n  font-size: var(--step-0);\n  margin-top: 0.3rem;\n}\n.contact-line {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding-block: 0.85rem;\n  border-bottom: 1px solid var(--line);\n}\n.contact-line:last-of-type { border-bottom: 0; }\n.contact-line__icon {\n  width: 36px; height: 36px;\n  flex: none;\n  display: grid;\n  place-items: center;\n  border-radius: 11px;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  color: var(--accent);\n}\n.contact-line__label {\n  font-family: var(--font-mono);\n  font-size: 0.64rem;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--text-dim);\n}\n.contact-line__value { font-weight: 500; word-break: break-word; }\n\n/* ---------- CTA band ---------- */\n.cta {\n  position: relative;\n  border-block: 1px solid var(--line);\n  padding: clamp(2.4rem, 1.8rem + 3vw, 4rem) 0;\n  text-align: center;\n}\n@keyframes spin { to { transform: rotate(1turn); } }\n.cta__title { font-size: var(--step-3); }\n.cta__lede { color: var(--text-soft); max-width: 52ch; margin: 0.8rem auto 1.8rem; }\n.cta__actions { display: flex; flex-wrap: wrap; gap: 0.8rem; justify-content: center; }\n\n/* ---------- Footer ---------- */\n.footer {\n  border-top: 1px solid var(--line);\n  padding-block: 2.4rem 2rem;\n  margin-top: auto;\n}\n.footer__inner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1.2rem;\n}\n.footer__brand { margin-right: auto; }\n.footer__copy { color: var(--text-dim); font-size: var(--step--1); font-family: var(--font-mono); }\n.footer__links { display: flex; gap: 0.5rem; flex-wrap: wrap; }\n.footer__meta {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-top: 1.6rem;\n  padding-top: 1.4rem;\n  border-top: 1px solid var(--line);\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  color: var(--text-dim);\n}\n.footer__meta b { color: var(--ok); font-weight: 500; }\n\n/* ---------- 404 ---------- */\n.notfound {\n  min-height: 100svh;\n  display: grid;\n  place-items: center;\n  text-align: center;\n  padding: calc(var(--nav-h) + 2rem) var(--gutter) 4rem;\n}\n.glitch {\n  position: relative;\n  font-size: var(--step-5);\n  font-family: var(--font-mono);\n  font-weight: 700;\n  letter-spacing: -0.05em;\n  line-height: 1;\n  color: var(--text);\n}\n.glitch::before,\n.glitch::after {\n  content: attr(data-text);\n  position: absolute;\n  inset: 0;\n  background: var(--bg);\n  clip-path: inset(0 0 60% 0);\n}\n.glitch::before {\n  color: var(--accent);\n  animation: glitchA 3.2s steps(2, end) infinite;\n}\n.glitch::after {\n  color: var(--text-dim);\n  clip-path: inset(60% 0 0 0);\n  animation: glitchB 2.7s steps(2, end) infinite;\n}\n@keyframes glitchA {\n  0%, 88%, 100% { transform: none; opacity: 0; }\n  90% { transform: translate(-4px, 2px); opacity: 1; }\n  94% { transform: translate(3px, -2px); opacity: 1; }\n}\n@keyframes glitchB {\n  0%, 85%, 100% { transform: none; opacity: 0; }\n  88% { transform: translate(4px, -2px); opacity: 1; }\n  92% { transform: translate(-3px, 2px); opacity: 1; }\n}\n\n/* ---------- Route loader ---------- */\n.route-loader {\n  min-height: 70svh;\n  display: grid;\n  place-items: center;\n  gap: 1rem;\n}\n.spinner {\n  width: 34px; height: 34px;\n  border-radius: 50%;\n  border: 2px solid var(--line-strong);\n  border-top-color: var(--accent);\n  animation: spin 0.8s linear infinite;\n}\n\n/* ---------- Case study ---------- */\n.prose { max-width: 72ch; }\n.prose h2 { font-size: var(--step-2); margin-top: 2.4rem; margin-bottom: 0.8rem; }\n.prose p { color: var(--text-soft); }\n.prose p + p { margin-top: 1rem; }\n.prose ul { display: grid; gap: 0.55rem; margin-top: 1rem; }\n.prose li {\n  position: relative;\n  padding-left: 1.4rem;\n  color: var(--text-soft);\n}\n.prose li::before {\n  content: \"▸\";\n  position: absolute;\n  left: 0;\n  top: 0.1em;\n  color: var(--accent);\n  font-size: 0.85em;\n}\n\n.shot {\n  border-radius: var(--r-lg);\n  overflow: hidden;\n  border: 1px solid var(--line);\n  margin-block: 2rem;\n  background: var(--surface);\n}\n\n/* ---------- Architecture diagram ---------- */\n.arch {\n  display: grid;\n  gap: clamp(1.2rem, 0.8rem + 1.6vw, 2rem);\n  align-items: start;\n}\n@media (min-width: 1040px) {\n  .arch { grid-template-columns: minmax(0, 1fr) minmax(0, 300px); }\n}\n\n.arch__canvas {\n  border: 1px solid var(--line);\n  border-radius: var(--r-lg);\n  background: var(--surface);\n  padding: clamp(0.6rem, 0.4rem + 0.8vw, 1.1rem);\n  overflow-x: auto;\n}\n.arch__svg {\n  width: 100%;\n  min-width: 620px;\n  height: auto;\n  display: block;\n}\n\n.arch__edge {\n  fill: none;\n  stroke: var(--line-strong);\n  stroke-width: 1.5;\n  color: var(--line-strong);\n  transition: stroke 0.3s var(--ease), color 0.3s var(--ease), stroke-width 0.3s var(--ease);\n}\n[data-lit=\"true\"] .arch__edge {\n  stroke: var(--accent);\n  color: var(--accent);\n  stroke-width: 2;\n}\n.arch__packet { fill: var(--accent); }\n\n.arch__node { cursor: pointer; outline: none; }\n.arch__node rect {\n  fill: var(--bg-elev);\n  stroke: var(--line-strong);\n  stroke-width: 1.5;\n  transition: stroke 0.28s var(--ease), fill 0.28s var(--ease), filter 0.28s var(--ease);\n}\n.arch__node[data-near=\"true\"] rect { stroke: color-mix(in srgb, var(--node-color) 55%, transparent); }\n.arch__node[data-active=\"true\"] rect {\n  stroke: var(--node-color);\n  stroke-width: 2;\n  fill: var(--surface-strong);\n}\n.arch__node:hover rect { stroke: var(--node-color); }\n.arch__node:focus-visible rect { stroke: var(--node-color); stroke-width: 2.5; }\n\n.arch__label {\n  fill: var(--text);\n  font-family: var(--font-sans);\n  font-size: 16px;\n  font-weight: 600;\n  text-anchor: middle;\n  pointer-events: none;\n}\n.arch__sub {\n  fill: var(--text-dim);\n  font-family: var(--font-mono);\n  font-size: 11px;\n  text-anchor: middle;\n  pointer-events: none;\n}\n\n.arch__panel {\n  border: 1px solid var(--line);\n  border-radius: var(--r-lg);\n  background: var(--surface);\n  padding: clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem);\n  position: sticky;\n  top: calc(var(--nav-h) + 1.2rem);\n}\n.arch__panel-eyebrow {\n  font-family: var(--font-mono);\n  font-size: 0.64rem;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n}\n.arch__panel-title { font-size: var(--step-2); margin: 0.3rem 0 0.7rem; }\n.arch__panel-body { color: var(--text-soft); font-size: var(--step-0); margin-bottom: 1rem; }\n.arch__panel-foot {\n  margin-top: 1.2rem;\n  padding-top: 0.9rem;\n  border-top: 1px solid var(--line);\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  color: var(--text-dim);\n}\n\n/* A moving dot is exactly what \"reduce motion\" is asking us not to do. */\n@media (prefers-reduced-motion: reduce) {\n  .arch__packet { display: none; }\n}\n\n/* ---------- Live GitHub activity ---------- */\n.activity { padding: clamp(1.1rem, 0.9rem + 0.6vw, 1.5rem); }\n.activity__head {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding-bottom: 0.9rem;\n  border-bottom: 1px solid var(--line);\n  flex-wrap: wrap;\n}\n.activity__head h3 {\n  font-size: var(--step-0);\n  font-weight: 600;\n  letter-spacing: 0;\n}\n.activity__head svg { color: var(--text-soft); }\n.activity__pulse {\n  width: 8px; height: 8px;\n  border-radius: 50%;\n  background: var(--ok);\n  animation: ping 2.2s var(--ease-in-out) infinite;\n}\n.activity__all {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  color: var(--text-dim);\n}\n.activity__all:hover { color: var(--accent); }\n\n.activity__list { display: grid; }\n.activity__row {\n  display: grid;\n  grid-template-columns: auto auto minmax(0, 1fr) auto;\n  align-items: baseline;\n  gap: 0.6rem;\n  padding: 0.62rem 0.2rem;\n  border-bottom: 1px solid var(--line);\n  font-family: var(--font-mono);\n  font-size: var(--step--1);\n  transition: padding-left 0.22s var(--ease), background-color 0.22s var(--ease);\n}\n.activity__list li:last-child .activity__row { border-bottom: 0; }\n.activity__row:hover { background: var(--surface); padding-left: 0.7rem; }\n.activity__verb { color: var(--accent); white-space: nowrap; }\n.activity__repo { color: var(--text); white-space: nowrap; }\n.activity__detail {\n  color: var(--text-dim);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.activity__when { color: var(--text-dim); white-space: nowrap; }\n\n.activity__row--skeleton { grid-template-columns: 1fr; }\n.skeleton-bar {\n  height: 12px;\n  border-radius: 99px;\n  background: linear-gradient(100deg, var(--surface) 30%, var(--surface-strong) 50%, var(--surface) 70%);\n  background-size: 220% 100%;\n  animation: sweep 1.4s linear infinite;\n}\n\n@media (max-width: 720px) {\n  .activity__row { grid-template-columns: auto minmax(0, 1fr); row-gap: 0.15rem; }\n  .activity__detail { grid-column: 1 / -1; }\n  .activity__when { grid-column: 1 / -1; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
